import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getSuppliersList = async (
  token,
  type = null,
  page = null,
  per_page = null,
  q,
  filter
) => {
  let endpoint =
    type === "all"
      ? `/api/v1/admin/suppliers?type=${type}`
      : `/api/v1/admin/suppliers?page=${page}&per_page=${per_page}`;
  if (q) {
    endpoint += `&q=${encodeURIComponent(q)}`;
  }
  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        endpoint += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    });
  }
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    // if (data.status.status === "SUCCESS") {
    return data;
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
